import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id D3EC3384-B91D-46C9-8D43-7D333DB2273D
 * name language-kotlin
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/language-kotlin.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const LanguageKotlinIcon = createSvgIcon(<><path d="M2 2H22L12 12L22 22H2Z" /></>, 'LanguageKotlinIcon');
export default LanguageKotlinIcon